<app-page title="Orders" [isLoading]="isLoading$ | async" [error]="error$ | async">
  <h2 class="mt-5 mb-5">Active Orders</h2>
  <app-orders-list
    [orders]="(activeOrders$ | async) || []"
    emptyMessageTitle="No active orders yet"
    emptyMessage="Any future active orders will appear here"
    [hasActionNeeded]="true"
    [hasLoadMore]="false"
    data-cy="active-orders-widget"
  ></app-orders-list>

  <h2 class="mt-6 mb-5">Completed Orders</h2>
  <app-orders-list
    [orders]="(completedOrders$ | async) || []"
    emptyMessageTitle="No completed orders yet"
    emptyMessage="Your completed orders will appear here when they have been shipped and delivered"
    [hasActionNeeded]="false"
    [hasLoadMore]="false"
    data-cy="completed-orders-widget"
  ></app-orders-list>
</app-page>
